<div class="p-8 border rounded-lg bg-card">
    <div class="pb-4 border-b">
        <h2 class="text-xl font-semibold">Processing Translations</h2>
        <p class="mt-1 text-secondary">
            Please wait while the AI translates the missing keys. This may take a few moments.
        </p>
    </div>

    <div class="mt-6 space-y-4">
        <div *ngFor="let lang of languageQueue" class="flex items-center p-4 rounded-md"
             [ngClass]="{
                'bg-gray-100 dark:bg-gray-700': lang.status === 'pending',
                'bg-blue-50 dark:bg-blue-900/30': lang.status === 'processing',
                'bg-green-50 dark:bg-green-900/30': lang.status === 'complete' || lang.status === 'skipped',
                'bg-red-50 dark:bg-red-900/30': lang.status === 'error'
             }">

            <!-- Icon -->
            <div class="mr-4">
                <mat-icon *ngIf="lang.status === 'pending'" class="text-gray-400">schedule</mat-icon>
                <mat-progress-spinner *ngIf="lang.status === 'processing'" mode="indeterminate" [diameter]="24"></mat-progress-spinner>
                <mat-icon *ngIf="lang.status === 'complete'" class="text-green-500">check_circle</mat-icon>
                <mat-icon *ngIf="lang.status === 'skipped'" class="text-gray-500">skip_next</mat-icon>
                <mat-icon *ngIf="lang.status === 'error'" class="text-red-500">error</mat-icon>
            </div>

            <!-- Text -->
            <div>
                <p class="font-semibold text-lg">{{ lang.code | uppercase }}</p>
                <p class="text-sm text-secondary">{{ lang.message }}</p>
            </div>
        </div>
    </div>

    <div *ngIf="!isProcessing && !overallError" class="mt-8 text-center">
        <p class="text-lg font-medium text-green-600">All translations processed successfully!</p>
        <p class="text-secondary">Moving to the review screen...</p>
    </div>

    <div *ngIf="overallError" class="mt-8 p-4 rounded-md bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-200">
        <p class="font-semibold">Processing Stopped</p>
        <p>{{ overallError }}</p>
    </div>
</div>
